import { Metric } from "@/entities/Finance/Finance.model";
import { DeltaLineageProps } from "./panels/DeltaLineagePanel";

export type DeltaFormula = { title?: string; formula: string[] };
export type DeltaResult = {
    value: number;
    previousFormula: DeltaFormula;
    currentFormula: DeltaFormula;
    deltaFormula: DeltaFormula;
};

export enum AIMViewType {
    DELTA_LINEAGE = "DELTA_LINEAGE",
    VALUE_LINEAGE = "VALUE_LINEAGE",
    LABS_LINEAGE = "LABS_LINEAGE",
}

export type AIMContextView =
    | {
          type: AIMViewType.DELTA_LINEAGE;
          props: DeltaLineageProps;
      }
    | {
          type: AIMViewType.VALUE_LINEAGE;
          metric: Metric | null;
          period: string;
          title: string;
      }
    | {
          type: AIMViewType.LABS_LINEAGE;
          metric: Metric | undefined;
          title: string;
      };
